import * as React from 'react';
import { Card, CardStyle } from './Card';

const innerStyle: string =
  'flex flex-column justify-center absolute bottom-0 left-0 right-0 top-0 items-center pa4';

export interface PromoCardProps {
  title: string;
  subtitle?: string;
  image_url?: string;
}

export const PromoCard = (props: PromoCardProps) => (
  <Card
    className={`${CardStyle.Default} animated fadeIn`}
    innerStyle={innerStyle}
  >
    <div className="">
      <img
        className="w4 h4 br-100 dib"
        src={props.image_url || '/images/methods/add.png'}
        alt={props.title}
      />
    </div>
    <h4 className="ma0 mt4 lh-copy f3 tc black">{props.title}</h4>
    <p className="ma0 mt3 lh-copy f5 tc black-70">{props.subtitle}</p>
  </Card>
);

export default PromoCard;
